/**
 * 分を時間と分に分割する
 * @param minutes 分
 * @returns {hours: number, minutes: number}
 */
export function parseMinutesToHourMinutes(minutes: number): {
  hours: number;
  minutes: number;
} {
  const hours = Math.floor(minutes / 60);
  const _minutes = Math.abs(Math.floor(minutes % 60));
  return { hours, minutes: _minutes };
}

/**
 * 分を時刻の表現形式(hh:mm形式)の文字列に変換する.
 * 例: 100 -> 1:40
 *
 * @param minutes 分
 * @returns hh:mm形式の文字列
 */
export function formatMinutesToHhmm(minutes: number): string {
  const { hours, minutes: _minutes } = parseMinutesToHourMinutes(minutes);
  return `${hours}:${_minutes.toString().padStart(2, "0")}`;
}

/**
 * hh:mm形式の文字列を分に変換する. 1:40 -> 100
 * @param hhmmStr hh:mm形式の文字列
 * @returns 分
 */
export function formatHhmmToMinutes(hhmmStr: string): number {
  const time = parseInt(hhmmStr.replace(":", ""));
  const hours = Math.floor(time / 100);
  const minutes = time % 100;
  return hours * 60 + minutes;
}
